import { ThemeStlye } from 'types/style/style.types';

export const theme: ThemeStlye = {
    mainColor: '#ebe4f9',
    subColor: '#222222',
};
